"use client"

import type { PropsWithChildren } from "react"
import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"

import * as css from "./styles.css"

type TemplateHeaderProps = PropsWithChildren<PropsWithClassName<{}>>

function TemplateHeader({ className, children }: TemplateHeaderProps) {
  return <section className={clsx(css.TemplateHeader, className)}>{children}</section>
}

export { TemplateHeader }
